(function () {
  function buildImageUrl(src, width) {
    if (!src) return null;
    try {
      var url = new URL(src, window.location.origin);
      url.searchParams.set('width', width);
      return url.toString();
    } catch (e) {
      return src;
    }
  }

  function init() {
    var mainImg = document.getElementById('lp-main-img');
    var variantInput = document.getElementById('lp-variant-id');
    if (!mainImg || !variantInput) return; // not a Lumafye custom product page

    var variantImageMap = null;
    var lastAppliedVariantId = null;
    var defaultImageSrc = mainImg.src;

    // ── Wide/composite image fit fix ─────────────────────────────
    // Kit/bundle products use a single wide banner-style image (multiple
    // items side by side with captions baked in) as their main photo.
    // The gallery's CSS always uses object-fit: cover, which is right for
    // normal square/portrait product photos but badly crops a wide banner
    // down to an unrecognizable sliver. Measure each image's real aspect
    // ratio once it loads and switch to object-fit: contain for anything
    // unusually wide, so the whole banner stays visible with letterboxing
    // instead of being cropped. Runs on every image swap (variant change,
    // thumbnail click) since all of them go through mainImg's load event.
    function applyFitForAspectRatio() {
      if (!mainImg.naturalWidth || !mainImg.naturalHeight) return;
      var ratio = mainImg.naturalWidth / mainImg.naturalHeight;
      mainImg.style.objectFit = ratio > 1.6 ? 'contain' : 'cover';
      mainImg.style.backgroundColor = ratio > 1.6 ? '#F3F1EA' : '';
    }
    mainImg.addEventListener('load', applyFitForAspectRatio);
    if (mainImg.complete) applyFitForAspectRatio();

    function ensureMapLoaded(callback) {
      if (variantImageMap) { callback(); return; }
      var path = window.location.pathname.replace(/\/$/, '') + '.js';
      fetch(path, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          variantImageMap = {};
          if (data && Array.isArray(data.variants)) {
            data.variants.forEach(function (v) {
              var img = v.featured_image;
              variantImageMap[String(v.id)] = img ? buildImageUrl(img.src, 1200) : null;
            });
          }
          callback();
        })
        .catch(function () {
          variantImageMap = {};
          callback();
        });
    }

    function applyForCurrentVariant() {
      var id = variantInput.value;
      if (!id || id === lastAppliedVariantId) return;
      var url = variantImageMap && variantImageMap[id];
      // Fall back to the page's original default image (not whatever was
      // showing before) when this variant has no explicit image of its own —
      // otherwise switching from a variant that DOES have a dedicated photo
      // back to one that doesn't leaves the wrong photo on screen.
      var targetUrl = url || defaultImageSrc;
      mainImg.src = targetUrl;
      lastAppliedVariantId = id;
      var thumbs = document.querySelectorAll('.lp-gallery__thumb');
      thumbs.forEach(function (t) {
        var dataSrc = t.getAttribute('data-src');
        var base = dataSrc ? dataSrc.split('?')[0] : null;
        var same = base && targetUrl.indexOf(base) === 0;
        t.classList.toggle('active', !!same);
      });
    }

    function handlePossibleVariantChange() {
      ensureMapLoaded(applyForCurrentVariant);
    }

    document.addEventListener('click', function (e) {
      var target = e.target && e.target.closest ? e.target.closest('.lp-option__btn') : null;
      if (target) {
        // Defer so this runs after the page's existing handler has already
        // resolved and written the correct variant id into #lp-variant-id.
        setTimeout(handlePossibleVariantChange, 0);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
